import React from 'react';
import EditApplicationPage from '../../../../components/EditApplicationPage';
import ApplicationPage from '../../../../pages/ApplicationPage';
import CreateNmsMeetingPage from '../../../../pages/CreateNmsMeetingPage';
import { CreateNmsMember } from '../../../../pages/CreateNmsMember/CreateNmsMember';
import { CreatePovsPage } from '../../../../pages/CreatePovsPage/CreatePovsPage';
import DocumentCategoryPage from '../../../../pages/DocumentCategoryPage';
import DocumentEditPage from '../../../../pages/DocumentEditPage';
import EditDocumentCategoryPage from '../../../../pages/EditDocumentCategoryPage';
import EditNmsMeetingPage from '../../../../pages/EditNmsMeetingPage';
import EditPovsPage from '../../../../pages/EditPovsPage';
import EditTextbook from '../../../../pages/EditTextbook';
import ExpertisePage from '../../../../pages/ExpertisePage';
import ExpertPage from '../../../../pages/ExpertPage';
import ExpertProfilePage from '../../../../pages/ExpertProfilePage';
import LkPovsPage from '../../../../pages/LkPovsPage';
import NewApplicationPage from '../../../../pages/NewApplicationPage';
import NewDocumentCategory from '../../../../pages/NewDocumentCategory';
import NewDocumentPage from '../../../../pages/NewDocumentPage';
import NewExpertPage from '../../../../pages/NewExpertPage';
import NewPublisherPage from '../../../../pages/NewPublisherPage';
import NmsMeetingInfoPage from '../../../../pages/NmsMeetingInfoPage';
import NmsMeetingPage from '../../../../pages/NmsMeetingPage';
import NmsMemberPage from '../../../../pages/NmsMemberPage';
import NmsMembers from '../../../../pages/NmsMembers';
import NmsProfilePage from '../../../../pages/NmsProfilePage';
import PublisherPage from '../../../../pages/PublisherPage';
import RepresentativePage from '../../../../pages/RepresentativePage';
import ShowApplicationPage from '../../../../pages/ShowApplicationPage';
import ShowTextbookPage from '../../../../pages/ShowTextbookPage';
import TextbookPage from '../../../../pages/TextbooksPage';
import { RoutePathsType } from '../../../../types';
import { routerPath } from '../../../routerPath';

export const lkRoutes: RoutePathsType = [
  {
    path: routerPath.application,
    name: 'Заявления',
    Component: <ApplicationPage />,
  },
  {
    path: routerPath.newApplication,
    name: 'Добавить заявление',
    Component: <NewApplicationPage />,
  },
  {
    path: routerPath.expert,
    name: 'Эксперты',
    Component: <ExpertPage />,
  },
  {
    path: routerPath.newExpert,
    name: 'Добавить эксперта',
    Component: <NewExpertPage />,
  },
  {
    path: routerPath.expertise,
    name: 'Экспертиза',
    Component: <ExpertisePage />,
  },
  {
    path: routerPath.textbooks,
    name: 'Учебники',
    Component: <TextbookPage />,
  },
  {
    path: routerPath.publisher,
    name: 'Издательства',
    Component: <PublisherPage />,
  },
  {
    path: routerPath.editPublisherId,
    name: 'Изменить издательство',
    Component: <NewPublisherPage />,
  },
  {
    path: routerPath.newPublisher,
    name: 'Добавить издательство',
    Component: <NewPublisherPage />,
  },
  {
    path: routerPath.representative,
    name: 'Представители издательств',
    Component: <RepresentativePage />,
  },
  {
    path: routerPath.document_category,
    name: 'Документы',
    Component: <DocumentCategoryPage />,
  },
  {
    path: routerPath.newDocumentCategory,
    name: 'Добавить документ',
    Component: <NewDocumentCategory />,
  },
  {
    path: routerPath.showApplicationId,
    name: 'Заявление',
    Component: <ShowApplicationPage />,
  },
  {
    path: routerPath.textbookId,
    name: 'Учебники экспертизы',
    Component: <ShowTextbookPage />,
  },
  {
    path: routerPath.editDocumentCategoryId,
    name: 'Изменение документа',
    Component: <EditDocumentCategoryPage />,
  },
  {
    path: routerPath.newDocumentId,
    name: 'Добавить подраздел',
    Component: <NewDocumentPage />,
  },
  {
    path: routerPath.editDocumentId,
    name: 'Изменить подраздел',
    Component: <DocumentEditPage />,
  },
  {
    path: routerPath.expertProfileId,
    name: 'Эксперт',
    Component: <ExpertProfilePage />,
  },
  {
    path: routerPath.nmsMembers,
    name: 'Члены НМС',
    Component: <NmsMembers />,
  },
  {
    path: routerPath.nmsMeeting,
    name: 'Заседания НМС',
    Component: <NmsMeetingPage />,
  },
  {
    path: routerPath.nmsProfile,
    name: 'Личный кабинет',
    Component: <NmsProfilePage />,
  },
  {
    path: routerPath.lkPovs,
    name: 'ПОВС',
    Component: <LkPovsPage />,
  },
  {
    path: routerPath.createNmsMember,
    name: 'Добавление члена НМС',
    Component: <CreateNmsMember />,
  },
  {
    path: routerPath.createPovsMember,
    name: 'Добавить повс',
    Component: <CreatePovsPage />,
  },
  {
    path: routerPath.editTextbookId,
    name: 'Учебники',
    Component: <EditTextbook />,
  },
  {
    path: routerPath.nmsFedInfoMeetingId,
    name: 'Заседание НМС',
    Component: <NmsMeetingInfoPage />,
  },
  {
    path: routerPath.createNmsMeeting,
    name: 'Добавить заседание НМС',
    Component: <CreateNmsMeetingPage />,
  },
  {
    path: routerPath.nmsMemberId,
    name: 'Член НМС',
    Component: <NmsMemberPage />,
  },
  {
    path: routerPath.editNmsMeetingId,
    name: 'Редактирование заседания НМС',
    Component: <EditNmsMeetingPage />,
  },
  {
    path: routerPath.editPovsId,
    name: 'Редактирование ПОВС',
    Component: <EditPovsPage />,
  },
  {
    path: routerPath.editApplicationId,
    name: 'Редактирование заявления',
    Component: <EditApplicationPage />,
  },
];
